const aiLabMediaObjectToTextQualityAssuranceStyles = {
  controlsContainer: {
    alignItems: "flex-start",
    marginBottom: 2,
  },
  caseFilterStatus: {
    alignItems: "center",
    minHeight: "2.5rem",
  },
  directIdControls: {
    alignItems: "flex-start",
  },
  directIdButton: {
    minWidth: "11rem",
    height: "3.5rem",
  },
  clickableRow: {
    cursor: "pointer",
  },
  centeredCell: {
    textAlign: "center",
    paddingY: 4,
  },
  paginationContainer: {
    justifyContent: "flex-end",
  },
  modalColumn: {
    minWidth: 0,
  },
  documentContainer: {
    height: "60vh",
    overflow: "auto",
    border: "1px solid",
    borderColor: "divider",
  },
  resultContainer: {
    height: "60vh",
    overflow: "auto",
    overflowWrap: "anywhere",
    whiteSpace: "pre-wrap",
    border: "1px solid",
    borderColor: "divider",
    padding: 2,
  },
  resultState: {
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  markdownText: {
    margin: 0,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
};

export default aiLabMediaObjectToTextQualityAssuranceStyles;
